import { render, staticRenderFns } from "./BidModifiersBadge.vue?vue&type=template&id=6cf65c6b&scoped=true"
import script from "./BidModifiersBadge.vue?vue&type=script&lang=js"
export * from "./BidModifiersBadge.vue?vue&type=script&lang=js"
import style0 from "./BidModifiersBadge.vue?vue&type=style&index=0&id=6cf65c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf65c6b",
  null
  
)

export default component.exports